import { render, staticRenderFns } from "./DeleteRecordModal.vue?vue&type=template&id=b7f92d2e&scoped=true"
import script from "./DeleteRecordModal.vue?vue&type=script&lang=js"
export * from "./DeleteRecordModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f92d2e",
  null
  
)

export default component.exports